import { useTranslation as originalUseTranslation } from "next-i18next"

export const useTranslation = originalUseTranslation

export const includeDefaultNamespaces = (namespaces: string[]): string[] => ["common"].concat(namespaces)
